import { useMutation } from "@tanstack/react-query";
import { axiosApi } from "./axios";
import { toast } from "react-toastify";
import { isAxiosError } from "axios";
import { SiretLookupResponse } from "@/types/api/api-types";

const lookupSiret = async (siret: string) => {
  const response = await axiosApi.get<SiretLookupResponse>(`/insee/siret/${siret}`);
  return response.data;
};

export const useLookupSiret = () => {
  return useMutation({
    mutationFn: lookupSiret,
    onError: (error) => {
      if (isAxiosError(error)) {
        if (error.response?.status === 404) {
          toast.error("SIRET non trouvé");
        } else if (error.response?.status === 503) {
          toast.error("Service INSEE indisponible, veuillez réessayer");
        } else {
          toast.error("Erreur lors de la recherche SIRET");
        }
      }
    },
  });
};
